import { localStorageService } from 'src/services/local-storage.service';
import { AuthService } from '.';

export async function HeimdallBFFLogout() {
  try {
    const info = localStorageService.getLocalStorageItem({
      key: 'user_token_login_info',
    });

    // se não tiver token, não tem como verificar se o usuário tem permissão para usar a nova tela de chats
    if (!info) {
      return null;
    }

    const response = await AuthService.logout(info?.token);

    localStorageService.removeLocalStorageItem({
      key: 'user_token_login_info',
    });

    return response.data;
  } catch (error) {
    console.error(
      'Erro ao verificar permissão de uso da nova tela de chats',
      error
    );
    //   TODO: rever retorno no caso de err
  }
}
